<template>
    <div class="user_all" v-loading=isResponse>
        <div class="user_search">
            <span style="width: 100px;display: inline-block">{{ $t('title.RPC_service') }}：</span>
            <el-select
                    style="width: 220px"
                    v-model="selectValue"
                    @change="changeRpc()"
                    :placeholder="this.$t('title.RPC_service')"
            >
                <el-option
                        v-for="item in options"
                        :key="item.rpcUrl"
                        :label="item.name"
                        :value="item.rpcUrl"
                ></el-option>
            </el-select>
            <el-select
                    style="margin-left: 5%;width: 220px"
                    v-model="selectChain"
                    @change="changeChain()"
                    :placeholder="$t('title.Please_select_the_chain')"
            >
                <el-option
                        v-for="item in options1"
                        :key="item"
                        :label="item+$t('title.chain')"
                        :value="item"
                ></el-option>
            </el-select>
        </div>
        <div class="user_search" style="display: flex">
            <el-button type="primary" @click="createdNode()" :loading=isResponse>生成NodeId</el-button>
        </div>
        <div class="user_search" style="display: flex">
            <el-input v-model="addIdValue" type="primary" style="width: 430px" placeholder="请输入"></el-input>
            <el-button type="primary" style="margin-left: 5%" @click="addId()" :loading=isResponse>增加</el-button>
        </div>
        <div class="user_search" style="display: flex">
            <el-select
                    style="width: 430px"
                    v-model="selectIdList"
                    placeholder="请选择"
            >
                <el-option
                        v-for="item in optionsIdList"
                        :key="item.nodeId"
                        :label="item.nodeId"
                        :value="item.nodeId"
                ></el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 5%" @click="delId()" :loading=isResponse>删除</el-button>
        </div>
        <div class="user_search" style="position: absolute;right: 21.8%">

            <el-button type="primary" style="margin-left: 30px" @click="searnode()">{{ $t('title.Refresh') }}
            </el-button>
        </div>
        <span style="display: inline-block">当前节点列表：</span>
        <div class="con_table">
            <el-table
                    :data="tableData"
                    border
                    height="320"
                    style="width: 80%;margin-bottom: 30px;margin-top: 40px"
                    :header-cell-style="this.tableHeaderColor"
            >
                <el-table-column
                        :label="this.$t('title.Serial_number')"
                        fixed
                        align="center"
                        width="90">
                    <template slot-scope="scope">
                        <span>{{scope.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.RPC_service')"
                        align="center"
                        width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.rpcServer}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                        label="nodeId"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.nodeId}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.address')"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.address}}</span>
                        <br>
                        <span>{{to_32_decimal(scope.row.address)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Chain_id')"
                        fixed="right"
                        width="150"
                        align="center"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.chainId}}</span>
                    </template>
                </el-table-column>

            </el-table>
            <!--            <el-pagination-->
            <!--                    background-->
            <!--                    @current-change="currentPageChange"-->
            <!--                    :current-page="currentPage"-->
            <!--                    :page-size="pagesize"-->
            <!--                    layout="total,prev, pager, next"-->
            <!--                    :total="total">-->
            <!--            </el-pagination>-->
        </div>
        <div class="user_search" style="float: right">

            <el-button type="primary" style="margin-left: 30px" @click="searlog()">{{ $t('title.Refresh') }}
            </el-button>
        </div>
        <span style="display: inline-block">操作历史：</span>
        <div class="con_table">
            <el-table
                    :data="tableData_1"
                    border
                    style="width: 100%;margin-bottom: 30px;margin-top: 40px;min-height: 200px"
                    :header-cell-style="this.tableHeaderColor"
            >
                <el-table-column
                        :label="this.$t('title.Serial_number')"
                        fixed
                        align="center"
                        width="90">
                    <template slot-scope="scope">
                        <span>{{scope.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.RPC_service')"
                        align="center"
                        width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.rpcServer}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Chain_id')"
                        align="center"
                        width="150"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.chainId}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="nodeId"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.nodeId}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.address')"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.address}}</span>
                        <br>
                        <span>{{to_32_decimal(scope.row.address)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                         :label="this.$t('title.Gas_fee')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.gasFee}}</span>

                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.status')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.type==0?'删除':'增加'}}</span>

                    </template>
                </el-table-column>
                <el-table-column
                        label="hash"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.hash}}</span>

                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Creation_time')"
                        fixed="right"
                        width="200"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{timestampToTime(scope.row.createTime)}}</span>
                    </template>
                </el-table-column>

            </el-table>
            <el-pagination
                    background
                    @current-change="currentPageChange_1"
                    :current-page="currentPage_1"
                    :page-size="pagesize_1"
                    layout="total,prev, pager, next"
                    :total="total_1">
            </el-pagination>
        </div>
    </div>

</template>

<script>
    import {
        getrpcserver,
        getchaininfo,
        createNode,
        addNode,
        listNode,
        delNode,
        logNodeList
    } from '../../../api/interface'

    export default {
        name: 'Node',
        components: {},
        data() {
            return {
                tableData: [],
                tableData_1: [],
                // currentPage: 1,
                // pagesize: 10,
                // total: 0,
                isResponse: false,
                selectValue: "",
                options: [],
                selectChain: '',
                options1: [],
                inputValue: '',
                searchValue: '',
                addIdValue: '',
                delIdValue: '',
                selectIdList: '',
                optionsIdList: [],

                currentPage_1: 1,
                pagesize_1: 10,
                total_1: 0,
            }
        },
        methods: {
            searlog(){
                this.getlogNodeList()

            },
            searnode(){
                this.getListNo()
            },
            createdNode() {
                this.isResponse = true
                let data = {
                    "rpcServer": this.selectValue,
                    "chainId": this.selectChain
                }
                createNode(data).then(response => {
                    this.isResponse = false
                    if (response.code == 200) {
                        this.addIdValue = response.data
                    } else {
                        this.$message.error(response.msg)
                    }
                })
            },
            addId() {

                if (this.addIdValue != '') {
                    let data = {
                        "rpcServer": this.selectValue,
                        "chainId": this.selectChain,
                        "nodeId": this.addIdValue
                    }
                    this.isResponse = true
                    addNode(data).then(response => {
                        this.isResponse = false
                        if (response.code == 200) {
                            this.$message.success('Success！')
                            this.getListNo()
                            this.getlogNodeList()
                        } else {
                            this.$message.success(response.msg)
                        }
                    })
                } else {
                    this.$message.error('请输入节点！')
                }
            },
            delId() {
                if (this.selectIdList != '') {
                    this.isResponse = true
                    let data = {
                        "rpcServer": this.selectValue,
                        "chainId": this.selectChain,
                        "nodeId": this.selectIdList
                    }
                    delNode(data).then(response => {
                        this.isResponse = false
                        if (response.code == 200) {
                            this.$message.success('Success！')
                            this.getListNo()
                            this.getlogNodeList()
                        } else {
                            this.$message.error(response.msg)
                        }
                    })
                } else {
                    this.$message.error('暂无可删除节点！')
                }

            },
            changeRpc() {
                this.isResponse = true
                let data = {rpcServer: this.selectValue}
                getchaininfo(data).then(response => {
                    this.options1 = response.data
                    this.selectChain = this.options1[0]
                    this.getListNo()
                })
            },
            changeChain() {
                this.isResponse = true
                this.getListNo()
            },
            getListNo() {
                let datas = {
                    "rpcServer": this.selectValue,
                    "chainId": this.selectChain,
                }
                listNode(datas).then(response => {
                    if (response.code == 200) {
                        this.tableData = response.data
                        this.isResponse = false
                        if (response.data.length > 0) {
                            this.optionsIdList = response.data
                            this.selectIdList = this.optionsIdList[0].nodeId
                        } else {
                            this.optionsIdList = []
                            this.selectIdList = ''
                        }

                    } else {
                        this.$message.error(response.msg)
                    }
                })
            },
            getlogNodeList() {
                this.currentPage_1 = 1
                let datas = {"address": "", "type": "", "page": 1, "rows": 10}
                logNodeList(datas).then(response => {
                    if (response.code == 200) {
                        this.tableData_1 = response.data.data
                        this.total_1=response.data.total
                        this.isResponse = false

                    } else {
                        this.$message.error(response.msg)
                    }
                })
            },
            currentPageChange_1(e) {
                this.currentPage_1 = e
                let datas = {"address": "", "type": "", "page": this.currentPage_1, "rows": 10}
                logNodeList(datas).then(response => {
                    if (response.code == 200) {
                        this.tableData_1 = response.data.data
                        this.total_1=response.data.total
                        this.isResponse = false

                    } else {
                        this.$message.error(response.msg)
                    }
                })
            },
            getData() {
                getrpcserver().then(response => {
                    this.options = response.data
                    this.selectValue = this.options[0].rpcUrl
                    let data = {rpcServer: this.options[0].rpcUrl}
                    getchaininfo(data).then(response => {
                        this.options1 = response.data
                        this.selectChain = this.options1[0]
                        this.getListNo()
                        this.getlogNodeList()
                    })
                })

            },
            currentPageChange(e) {
                this.currentPage = e
                this.getTableData(this.searchValue, this.currentPage, 0)
            },
        },
        created() {
            this.getData()
        }

    }
</script>
<style scoped>
    .user_all {
        padding: 20px 30px;
    }

    .user_search {
        margin-bottom: 30px;
    }
</style>
